export const object_extends = Object.assign || function (target) {
  for (let i = 1; i < arguments.length; i++) {
    const source = arguments[i];
    for (let key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};

export function date_format(date, format) {
  if (typeof date === 'string') {
    const parsedDate = new Date(date);

    if (parsedDate.toString() !== 'Invalid Date') {
      date = parsedDate;
    } else {
      format = date;
      date = new Date();
    }
  }

  if (!format) {
    format = 'yyyy-MM-dd hh:mm';
  }

  const map = {
    "M": date.getMonth() + 1, //月份
    "d": date.getDate(), //日
    "h": date.getHours(), //小时
    "m": date.getMinutes(), //分
    "s": date.getSeconds(), //秒
    "q": Math.floor((date.getMonth() + 3) / 3), //季度
    "S": date.getMilliseconds() //毫秒
  };
  format = format.replace(/([yMdhmsqS])+/g, function (all, t) {
    let v = map[t];
    if (v !== undefined) {
      if (all.length > 1) {
        v = '0' + v;
        v = v.substr(v.length - 2);
      }
      return v;
    }
    else if (t === 'y') {
      return (date.getFullYear() + '').substr(4 - all.length);
    }
    return all;
  });
  return format;
}

export function isNull(s) {
  if (!s) return true;
  s = s.replace(/&nbsp;/ig, ""); //去掉&nbsp;
  const patrn = /^\s*$/;
  if (!patrn.exec(s)) return false;
  return true;
}

export function isMobile(mobile) {
  if (isNull(mobile))
    return false;
  const mobileReg = !!mobile.match(/^(0|86|17951)?(13[0-9]|15[012356789]|17[03678]|18[0-9]|14[57])[0-9]{8}$/);
  return mobileReg;
}

export function buttonHelper(btn, disabledText) {
  const buttonIsInput = btn.tagName === 'INPUT';
  const originalBtnText = buttonIsInput ? btn.value : btn.innerHTML;

  return {
    disable: function () {
      btn.setAttribute('disabled', 'disabled');
      if (buttonIsInput) {
        btn.value = disabledText || '正在执行操作，请耐心等待...';
      } else {
        btn.innerHTML = disabledText || '正在执行操作，请耐心等待...';
      }
    },
    enable: function () {
      btn.removeAttribute('disabled');
      if (buttonIsInput) {
        btn.value = originalBtnText;
      } else {
        btn.innerHTML = originalBtnText;
      }
    },
    setText: function (text) {
      if (buttonIsInput) {
        btn.value = text;
      } else {
        btn.innerHTML = text;
      }
    },
    isDisabled: function () {
      return btn.getAttribute('disabled') !== null;
    }
  }
}

export function getQueryString(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  const regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

export function countDown(display, duration, formatter, completeCallback) {
  let start = Date.now(),
    diff,
    minutes,
    seconds;
  const originalText = display.textContent;

  let intervalTimer = setInterval(timer, 1000);

  function timer() {
    diff = duration - (((Date.now() - start) / 1000) | 0);

    minutes = (diff / 60) | 0;
    seconds = (diff % 60) | 0;

    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    display.textContent = formatter ? formatter(minutes, seconds) : (minutes + ":" + seconds);

    if (diff <= 0) {
      clearInterval(intervalTimer);

      start = Date.now() + 1000;

      display.textContent = originalText;
      completeCallback && completeCallback(originalText);
    }
  }

  timer();
}



// WEBPACK FOOTER //
// ./src/utils/helper.js